document.addEventListener("DOMContentLoaded", function () {
  // 1. Create the progress bar HTML string
  const progressBarHTML = `
    <div class="tripsitter-progress" id="progress-section" role="navigation" aria-label="Journey progress indicator">
      <div class="tripsitter-progress__container">
        <div class="tripsitter-progress__bar">
          <div class="tripsitter-progress__step tripsitter-progress__step--optimize" data-step="optimize">
            <div class="tripsitter-progress__step-icon">🚀</div>
            <span class="tripsitter-progress__step-label">OPTIMIZE</span>
          </div>
          <div class="tripsitter-progress__line tripsitter-progress__line--1"></div>
          <div class="tripsitter-progress__step tripsitter-progress__step--journey" data-step="journey">
            <div class="tripsitter-progress__step-icon">🌌</div>
            <span class="tripsitter-progress__step-label">JOURNEY</span>
          </div>
          <div class="tripsitter-progress__line tripsitter-progress__line--2"></div>
          <div class="tripsitter-progress__step tripsitter-progress__step--alchemize" data-step="alchemize">
            <div class="tripsitter-progress__step-icon">🛬</div>
            <span class="tripsitter-progress__step-label">ALCHEMIZE</span>
          </div>
        </div>
      </div>
    </div>
  `;

  // 2. Inject the HTML directly into the <body>
  document.body.insertAdjacentHTML("beforeend", progressBarHTML);

  // 3. Now that the element exists, find its parts and add functionality
  initProgressBarFunctionality();
});

function initProgressBarFunctionality() {
  const progressBar = document.querySelector(".tripsitter-progress");
  if (!progressBar) return;

  const progressSteps = progressBar.querySelectorAll(
    ".tripsitter-progress__step"
  );
  const progressLines = progressBar.querySelectorAll(
    ".tripsitter-progress__line"
  );

  if (progressSteps.length === 0) return;

  // Add click handlers for navigation
  const optimizeStep = progressBar.querySelector('[data-step="optimize"]');
  const journeyStep = progressBar.querySelector('[data-step="journey"]');
  const alchemizeStep = progressBar.querySelector('[data-step="alchemize"]');

  optimizeStep?.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  journeyStep?.addEventListener("click", () => {
    const ctaSection = document.getElementById("cta-section");
    if (ctaSection) {
      ctaSection.scrollIntoView({ behavior: "smooth" });
    }
  });

  alchemizeStep?.addEventListener("click", () => {
    const scienceSections = document.querySelectorAll("#science-section");
    if (scienceSections.length > 1) {
      // Target the second instance of #science-section
      scienceSections[1].scrollIntoView({ behavior: "smooth" });
    } else if (scienceSections.length === 1) {
      // Fallback to first instance if only one exists
      scienceSections[0].scrollIntoView({ behavior: "smooth" });
    }
  });

  function updateProgress() {
    const scrollPosition = window.pageYOffset;
    const ctaSection = document.getElementById("cta-section");
    const scienceSections = document.querySelectorAll("#science-section");
    const scienceSection =
      scienceSections.length > 1 ? scienceSections[1] : scienceSections[0];

    // Clear all active states
    progressSteps.forEach((step) => step.classList.remove("active"));
    progressLines.forEach((line) => line.classList.remove("active"));

    // Determine which section we're currently in
    let currentSection = "optimize"; // Default to optimize (top of page)

    // Check sections in order from top to bottom
    if (ctaSection) {
      const ctaTop = ctaSection.offsetTop - 200; // 200px offset for early activation
      if (scrollPosition >= ctaTop) {
        currentSection = "journey";
      }
    }

    // Smart ALCHEMIZE activation logic
    if (scienceSection && ctaSection) {
      const ctaBottom = ctaSection.offsetTop + ctaSection.offsetHeight;
      const scienceTop = scienceSection.offsetTop - 200; // More lenient buffer
      const scienceBottom =
        scienceSection.offsetTop + scienceSection.offsetHeight;

      // Check if we're currently viewing the second science section
      const viewingSecondScienceSection =
        scrollPosition >= scienceTop && scrollPosition <= scienceBottom + 500;

      // ALCHEMIZE activates when:
      // 1. We're viewing the second science section (direct navigation)
      // OR
      // 2. We've scrolled past it AND the CTA section is completely out of view (natural scroll)
      const ctaCompletelyGone = ctaBottom < scrollPosition;

      if (
        viewingSecondScienceSection ||
        (scrollPosition >= scienceTop + 500 && ctaCompletelyGone)
      ) {
        currentSection = "alchemize";
      }
    }

    // Activate only the current section
    if (currentSection === "optimize") {
      progressBar
        .querySelector('[data-step="optimize"]')
        ?.classList.add("active");
    } else if (currentSection === "journey") {
      progressBar
        .querySelector('[data-step="journey"]')
        ?.classList.add("active");
    } else if (currentSection === "alchemize") {
      progressBar
        .querySelector('[data-step="alchemize"]')
        ?.classList.add("active");
    }
  }

  let ticking = false;
  function handleScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateProgress();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener("scroll", handleScroll, { passive: true });
  updateProgress();
}
